export const CLINICAL_HUD3_TEACHING_PATH = "/clinical-hud-3";
export const CLINICAL_HUD3_LIVE_PATH = "/clinical-hud-3/live";

export function clinicalHud3TeachingSessionPath(sessionId) {
  return `${CLINICAL_HUD3_TEACHING_PATH}/case/${sessionId}`;
}

export function clinicalHud3LiveSessionPath(sessionId) {
  return `${CLINICAL_HUD3_LIVE_PATH}/${sessionId}`;
}
